import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustFeatures = [
    {
      icon: 'Lock',
      title: '100% Confidential',
      description: 'Your responses are encrypted. Never shared. Period.'
    },
    {
      icon: 'Shield',
      title: 'Secure Infrastructure',
      description: 'Bank-level encryption protects your data'
    },
    {
      icon: 'UserCheck',
      title: 'Private Results',
      description: 'Only you have access to your assessment'
    },
    {
      icon: 'Award',
      title: 'Research-Based',
      description: 'Built on validated psychological principles'
    }
  ];

  return (
    <div className="w-full max-w-5xl mx-auto px-4 md:px-6 lg:px-8">
      <div className="text-center mb-10 md:mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-white mb-4 uppercase tracking-tight">
          Your Privacy Is Non-Negotiable
        </h2>
        <p className="text-lg md:text-xl text-brand-steel max-w-2xl mx-auto">
          We don't sell data. We don't share information. We protect what's yours.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {trustFeatures?.map((feature, index) => (
          <div 
            key={index}
            className="bg-brand-charcoal rounded-lg p-7 md:p-8 border border-brand-slate hover:border-brand-gold transition-all duration-250"
          >
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-md bg-brand-gold/10 flex items-center justify-center flex-shrink-0">
                <Icon 
                  name={feature?.icon} 
                  size={24} 
                  color="#C9A227"
                />
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-brand-white text-lg mb-2 uppercase tracking-wide">
                  {feature?.title}
                </h3>
                <p className="text-base text-brand-steel leading-relaxed">
                  {feature?.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Security Badges */}
      <div className="mt-10 flex flex-wrap items-center justify-center gap-6">
        <div className="flex items-center gap-2 px-5 py-3 bg-brand-charcoal rounded-md border border-brand-slate">
          <Icon name="Lock" size={16} color="#C9A227" />
          <span className="text-sm font-semibold text-brand-white uppercase tracking-wide">256-bit SSL</span>
        </div>
        <div className="flex items-center gap-2 px-5 py-3 bg-brand-charcoal rounded-md border border-brand-slate">
          <Icon name="Shield" size={16} color="#C9A227" />
          <span className="text-sm font-semibold text-brand-white uppercase tracking-wide">GDPR Compliant</span>
        </div>
        <div className="flex items-center gap-2 px-5 py-3 bg-brand-charcoal rounded-md border border-brand-slate">
          <Icon name="CheckCircle" size={16} color="#C9A227" />
          <span className="text-sm font-semibold text-brand-white uppercase tracking-wide">Privacy Certified</span>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;